import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { IBM_TABLES } from "../dict/ibm/tables";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class MaestrosService {
  constructor(private http: HttpClient) { }

  //We get any collection from the DB
  getCollection(table: string) {
    if (table === IBM_TABLES.CER019) {
      return this.http.get<any>(environment.rutas.maestros.brokersSellers.getBrokersSellers)
        .pipe(map(response => response.data));
    }
    if (table === IBM_TABLES.CER050TC) {
      return this.http.get<any>(environment.rutas.maestros.proformas.getProformas)
        .pipe(map(response => response.data));
    }
    return this.http.get<any>(environment.rutas.maestros.getDB + '/' + table);
  }

  getCount(table: string) {
    if (table === IBM_TABLES.CER019) {
      return this.http.get<any>(environment.rutas.maestros.brokersSellers.getBrokersSellersCount)
        .pipe(map(response => response.data.count));
    }
    if (table === IBM_TABLES.CER050TC) {
      return this.http.get<any>(environment.rutas.maestros.proformas.getProformasCount)
        .pipe(map(response => response.data.count));
    }
    return this.http.get<any>(environment.rutas.maestros.getCount + '/' + table);
  }
}